import { languages } from "@/data/trinityI18n";

const supportedLanguageCodes = languages.map((language) => language.code);

export const isSupportedLanguage = (languageCode) => supportedLanguageCodes.includes(languageCode);

export const getStoredLanguage = (storageKey, fallbackLanguage = "en") => {
  try {
    const storedLanguage = window.localStorage.getItem(storageKey);
    return isSupportedLanguage(storedLanguage) ? storedLanguage : fallbackLanguage;
  } catch {
    return fallbackLanguage;
  }
};

export const storeLanguage = (storageKey, languageCode) => {
  if (!isSupportedLanguage(languageCode)) return;
  try {
    window.localStorage.setItem(storageKey, languageCode);
  } catch {
    void storageKey;
  }
};